import { FC } from 'react';
import { IconMoodX } from '@tabler/icons-react';

import { sentimentColors, sentimentIcons } from 'constants/reporting';
import { getHighestSentiment } from 'pages/reporting/utils';
import { ICallSentiment } from 'interfaces/Reporting';

interface SentimentSmileyProps {
  callSentiment: ICallSentiment;
  size: number;
}

const SentimentSmiley: FC<SentimentSmileyProps> = ({ callSentiment, size }) => {
  const [sentiment, sentimentValue] = getHighestSentiment(callSentiment);
  const SentimentSmiley = sentimentIcons[sentiment];
  const isSentimentEmpty = sentimentValue === 0;

  if (isSentimentEmpty) {
    return (
      <IconMoodX size={size} stroke={1.5} color="var(--mantine-color-gray-5)" />
    );
  }

  return (
    <SentimentSmiley
      size={size}
      stroke={1.5}
      color={sentimentColors[sentiment]}
    />
  );
};

export default SentimentSmiley;
